import { Link } from "react-router-dom";
import { FIRM } from "@/data/content";

const NAV = [
    { to: "/services", label: "Services" },
    { to: "/about", label: "About" },
    { to: "/insights", label: "Insights" },
    { to: "/capabilities", label: "Capabilities" },
    { to: "/contact", label: "Contact" },
    { to: "/pay", label: "Client Payments" },
];

export const Footer = () => (
    <footer className="border-t border-slate-800/70 bg-[#05070b]">
        <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 lg:grid-cols-12 lg:px-12 lg:py-20">
            <div className="lg:col-span-5">
                <p className="font-serif text-2xl text-slate-100">{FIRM.name}</p>
                <p className="mt-3 max-w-sm text-sm leading-relaxed text-slate-500">
                    A principal-led advisory practice serving collection agency and receivables industry
                    executives, from Tucson, Arizona, to engagements nationwide.
                </p>
                <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-600">
                    {FIRM.coordinates}
                </p>
            </div>
            <nav aria-label="Footer" className="lg:col-span-3">
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">Site</p>
                <ul className="mt-5 space-y-3">
                    {NAV.map((l) => (
                        <li key={l.to}>
                            <Link
                                to={l.to}
                                data-testid={`footer-${l.label.toLowerCase()}-link`}
                                className="text-sm text-slate-400 transition-colors duration-300 hover:text-slate-100"
                            >
                                {l.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
            <div className="lg:col-span-4">
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">
                    Discretion
                </p>
                <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-500">
                    Client identities, engagement details, and findings are never disclosed.
                    Credentials and references are furnished only when verified and with consent.
                </p>
            </div>
        </div>
        <div className="border-t border-slate-800/70">
            <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-6 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-600 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-12">
                <span>© {new Date().getFullYear()} {FIRM.name}</span>
                <span>Tucson, Arizona · In business since 2004</span>
            </div>
        </div>
    </footer>
);
